import * as squint_core from 'squint-cljs/core.js';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as page from './cljdoc.client.page.jsx';
import * as cljdoc_DOT_client_DOT_page from './cljdoc.client.page.jsx';
var init_toggle_docstring_raw = function () {
const toggles_1 = dom.query_all(".js--toggle-raw");
const add_toggle_handlers_2 = (function () {
for (let G__3 of squint_core.iterable(toggles_1)) {
const el_4 = G__3;
el_4.addEventListener("click", (function () {
const parent_5 = el_4.parentElement;
const markdowns_6 = dom.query_all(".markdown", parent_5);
const raws_7 = dom.query_all(".raw", parent_5);
for (let G__8 of squint_core.iterable(squint_core.map_indexed(squint_core.vector, markdowns_6))) {
const vec___9_12 = G__8;
const ndx_13 = squint_core.nth(vec___9_12, 0, null);
const markdown_14 = squint_core.nth(vec___9_12, 1, null);
const raw_15 = ((squint_core.truth_(raws_7)) ? (squint_core.get(raws_7, ndx_13)) : (null));
const hide_16 = "dn";
if (squint_core.truth_(dom.has_class_QMARK_(markdown_14, hide_16))) {
dom.remove_class(markdown_14, hide_16);
if (squint_core.truth_(raw_15)) {
dom.add_class(raw_15, hide_16)};
el_4.innerText = "raw docstring"} else {
dom.add_class(markdown_14, hide_16);
if (squint_core.truth_(raw_15)) {
dom.remove_class(raw_15, hide_16)};
el_4.innerText = "formatted docstring"}
}
return null;

}))
}
return null;

});
return add_toggle_handlers_2();

};
var init = function () {
if (squint_core.truth_((() => {
const or_1_2 = page.is_namespace_overview();
if (squint_core.truth_(or_1_2)) {
return or_1_2} else {
const or_3_4 = page.is_namespace();
if (squint_core.truth_(or_3_4)) {
return or_3_4} else {
return page.is_namespace_offline()};
};

})())) {
return init_toggle_docstring_raw();
};

};

export { init }
